<script>
import BitrixImage from "@/components/commonComponents/BitrixImage.vue";
import VBaseCardAjaxList from "@/components/commonComponents/VBaseCardAjaxList.vue";

export default {
    name: "VCardForums",
    components: {
        VBaseCardAjaxList,
        BitrixImage,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    methods: {
        getLinkToForum(item) {
            return {name: 'ForumEvents', params: {ID_FORUM: item.ID}};
        },
    },
}
</script>

<template>
    <v-base-card-ajax-list
        :url="url"
        v-bind="$attrs"
        v-slot="{item}"
    >
        <v-list-item :key="item.ID" :to="getLinkToForum(item)">
            <v-list-item-avatar>
                <bitrix-image :file="item.PREVIEW_PICTURE_FILE"></bitrix-image>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ item.NAME_FULL.VALUE }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-base-card-ajax-list>
</template>

<style scoped lang="scss">

</style>